import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.lastSubmittedUrl = null;
    this.isInitialized = false;
    this.submitTimeout = null;
    this.initializeFormState();
    this.syncAllCheckboxes();
    this.setupSearchInput();

    document.addEventListener('turbo:frame-load', (event) => {
      if (event.target.id === "education_articles_data") {
        setTimeout(() => {
          this.initializeFormState();
          this.syncAllCheckboxes();
          this.setupSearchInput();
        }, 50);
      }
    });

    window.addEventListener('popstate', () => {
      setTimeout(() => {
        this.initializeFormState();
        this.syncAllCheckboxes();
        this.setupSearchInput();
        this.submitFormIfNeeded();
      }, 100);
    });

    document.addEventListener('turbo:load', () => {
      this.initializeFormState();
      this.syncAllCheckboxes();
      this.setupSearchInput();
      this.submitFormIfNeeded();
    });

    this.element.addEventListener('initialize-form-state', (event) => {
      if (!this.isInitialized) {
        this.initializeFormState();
        this.syncAllCheckboxes();
        this.setupSearchInput();
        this.submitFormIfNeeded();
        this.isInitialized = true;
      }
    });
  }

  initializeFormState() {
    const form = document.getElementById('education-article-filter-form');
    if (!form) return;

    const urlParams = new URLSearchParams(window.location.search);

    const searchInput = document.getElementById('title-search-input');
    if (searchInput) {
      let searchValue = urlParams.get('q') || '';

      if (!searchValue) {
        const storedValue = sessionStorage.getItem('education_search_value');
        if (storedValue) {
          searchValue = storedValue;
        }
      }

      searchInput.value = searchValue;
      this.updateSearchIcon(searchValue);
    }

    const categoryValue = urlParams.get('category') || '';
    this.initializeRadioButtons('input[name="category"]', categoryValue);
  }

  initializeRadioButtons(selector, selectedValue) {
    const radioButtons = document.querySelectorAll(selector);
    radioButtons.forEach(radio => {
      if (selectedValue === '') {
        if (radio.value === '') {
          radio.checked = true;
        } else {
          radio.checked = false;
        }
      } else {
        radio.checked = radio.value === selectedValue;
      }
    });
  }

  syncAllCheckboxes() {
    const categoryRadios = document.querySelectorAll('input[name="category"]');
    categoryRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        this.submitForm();
      });
    });
  }

  setupSearchInput() {
    const searchInput = document.getElementById('title-search-input');
    if (searchInput) {
      searchInput.addEventListener('input', () => {
        this.updateSearchIcon(searchInput.value);
        this.submitForm();
      });
    }
  }

  updateSearchIcon(searchValue) {
    const searchBtn = document.getElementById('search-btn');
    const clearBtn = document.getElementById('clear-search-btn');
    
    if (searchBtn && clearBtn) {
      if (searchValue.trim() === '') {
        searchBtn.classList.remove('hidden');
        clearBtn.classList.add('hidden');
      } else {
        searchBtn.classList.remove('hidden');
        clearBtn.classList.remove('hidden');
      }
    }
  }

  submitForm() {
    const form = document.getElementById('education-article-filter-form');
    if (form) {
      if (this.submitTimeout) {
        clearTimeout(this.submitTimeout);
      }

      this.submitTimeout = setTimeout(() => {
        const formData = new FormData(form);
        const params = new URLSearchParams();

        for (const [key, value] of formData.entries()) {
          if (value !== null && value !== undefined && value !== '') {
            params.append(key, value);
          }
        }

        const queryString = params.toString();
        const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
        
        if (this.lastSubmittedUrl !== newUrl) {
          this.lastSubmittedUrl = newUrl;
          window.history.pushState({}, '', newUrl);
          form.requestSubmit();
        }
      }, 300);
    }
  }

  submitFormIfNeeded() {
    const form = document.getElementById('education-article-filter-form');
    if (form) {
      const formData = new FormData(form);
      const params = new URLSearchParams();

      for (const [key, value] of formData.entries()) {
        if (value !== null && value !== undefined && value !== '') {
          params.append(key, value);
        }
      }

      const queryString = params.toString();
      const currentUrl = window.location.search.substring(1);
      
      if (queryString !== currentUrl) {
        this.submitForm();
      }
    }
  }

  handleCustomFilterReset() {
    const form = document.getElementById('education-article-filter-form');
    if (form) {
      const searchInput = document.getElementById('title-search-input');
      if (searchInput) {
        searchInput.value = '';
        sessionStorage.removeItem('education_search_value');
        this.updateSearchIcon('');
      }

      const allCategoryRadio = document.getElementById('category-all');
      if (allCategoryRadio) {
        allCategoryRadio.checked = true;
      }

      const categoryRadios = document.querySelectorAll('input[name="category"]:not(#category-all)');
      categoryRadios.forEach(radio => {
        radio.checked = false;
      });

      this.submitForm();
    }
  }

  updateUrlOnSubmit(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value !== null && value !== undefined && value !== '') {
        params.append(key, value);
      }
    }

    const queryString = params.toString();
    const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
    window.history.pushState({}, '', newUrl);
  }

  submitTitleSearch() {
    const input = document.getElementById('title-search-input');
    if (input) {
      const searchValue = input.value.trim();

      const searchBtn = document.getElementById('search-btn');
      const clearBtn = document.getElementById('clear-search-btn');
      if (searchBtn && clearBtn) {
        if (searchValue === '') {
          searchBtn.classList.remove('hidden');
          clearBtn.classList.add('hidden');
        } else {
          searchBtn.classList.remove('hidden');
          clearBtn.classList.remove('hidden');
        }
      }

      const form = document.getElementById('education-article-filter-form');
      if (form) {
        if (searchValue !== '') {
          sessionStorage.setItem('education_search_value', searchValue);
        } else {
          sessionStorage.removeItem('education_search_value');
        }

        this.updateUrlOnSubmit(form);
        form.requestSubmit();
      }
    }
  }

  clearTitleSearch() {
    const input = document.getElementById('title-search-input');
    if (input) {
      input.value = '';
      sessionStorage.removeItem('education_search_value');
      
      const searchBtn = document.getElementById('search-btn');
      const clearBtn = document.getElementById('clear-search-btn');
      if (searchBtn && clearBtn) {
        searchBtn.classList.remove('hidden');
        clearBtn.classList.add('hidden');
      }

      const form = document.getElementById('education-article-filter-form');
      if (form) {
        this.updateUrlOnSubmit(form);
        form.requestSubmit();
      }
    }
  }
} 